import { PartialServiceCases } from "./partialServiceConditions";

export enum NetworkImprovementTipsStatus {
    Default = "Default",
    OnFirstPlace = "OnFirstPlace",
    Hidden = "Hidden",
}

export enum PartialServiceDialogKind {
    None = "None",
    Reset = "Reset",
    Callback = "Callback"
}

export enum TipStatus {
    Hidden = "Hidden",
    Visible = "Visible",
}

export interface PartialServiceState {
    partialServiceDialogKind: PartialServiceDialogKind;
    networkImprovementTipsStatus: NetworkImprovementTipsStatus;
    modemResetTipStatus: TipStatus;
    callbackTipStatus: TipStatus;
}

export const initialState: PartialServiceState = {
    partialServiceDialogKind: PartialServiceDialogKind.None,
    networkImprovementTipsStatus: NetworkImprovementTipsStatus.Default,
    modemResetTipStatus: TipStatus.Hidden,
    callbackTipStatus: TipStatus.Hidden,
}

/* pure */
export const getPartialServiceState = (psCase: PartialServiceCases, afterMeasurement: boolean): PartialServiceState => {
    switch (psCase) {
        case PartialServiceCases.FirstStartResultIsNotOkInterfaceHasErrors:
        case PartialServiceCases.FirstStartResultIsOkInterfaceHasManyErrors:
            return {
                partialServiceDialogKind: afterMeasurement ? PartialServiceDialogKind.Reset : PartialServiceDialogKind.None,
                networkImprovementTipsStatus: NetworkImprovementTipsStatus.Hidden,
                modemResetTipStatus: TipStatus.Visible,
                callbackTipStatus: TipStatus.Hidden,
            }
        case PartialServiceCases.FirstStartCase3:
            return {
                partialServiceDialogKind: PartialServiceDialogKind.None,
                networkImprovementTipsStatus: NetworkImprovementTipsStatus.OnFirstPlace,
                modemResetTipStatus: TipStatus.Hidden,
                callbackTipStatus: TipStatus.Hidden,
            }
        case PartialServiceCases.AgainResultIsNotOkInterfaceHasManyErrors:
            return {
                partialServiceDialogKind: afterMeasurement ? PartialServiceDialogKind.Callback : PartialServiceDialogKind.None,
                networkImprovementTipsStatus: NetworkImprovementTipsStatus.Hidden,
                modemResetTipStatus: TipStatus.Hidden,
                callbackTipStatus: TipStatus.Visible,
            }
        case PartialServiceCases.Default:
            return initialState;
    }
}